import React, { ChangeEventHandler, useRef, useState, useEffect } from "react";
import { ArrowDown, ArrowUp, Clear_Large } from "./ProjectIcons";
import { useTranslation } from "react-i18next";
import { selectListClasses } from "./tailwindClassnames";

type SelectListProps = {
    optionList: any[],
    selectedList: any[],
    onChangeFilter?: ChangeEventHandler,
    onChangeSearchBar?: ChangeEventHandler,
    sectionLabel: string,
    onClickLoadMore?: () => void,
    loadMore: boolean,
    loading: boolean
}

const SelectList = ({
    optionList,
    selectedList,
    onChangeFilter,
    onChangeSearchBar,
    sectionLabel,
    onClickLoadMore,
    loadMore,
    loading
}: SelectListProps) => {
    const { t } = useTranslation();
    const [subStr, setSubStr] = useState("");
    const [expanded, setExpanded] = useState(true);
    const toggleExpanded = () => setExpanded(!expanded);
    const scrollContainerRef = useRef<HTMLDivElement>(null);

    const handleLoadMore = async () => {
        if (onClickLoadMore) {
            await onClickLoadMore();
        }

        // Scroll to the bottom of the container
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollTop = scrollContainerRef.current.scrollHeight;
        }
    };

    useEffect(() => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollTop = 0;
        }
    }, []);

    return (
        <div className={selectListClasses.container}>
            {/* input box to refine list */}
            <div className={selectListClasses.header} onClick={toggleExpanded}>
                <label className={selectListClasses.sectionLabel}>{sectionLabel}</label>{expanded ? <ArrowUp /> : <ArrowDown />}
            </div>
            {expanded &&
                <div>
                    <div className="relative">
                        <input
                            id="name"
                            placeholder=""
                            value={subStr}
                            className={selectListClasses.input}
                            onChange={(e) => {
                                setSubStr(e.target.value)
                                onChangeSearchBar && onChangeSearchBar(e)
                            }}
                        />
                        {subStr && (
                            <button
                                className={selectListClasses.clearButton}
                                onClick={() => {
                                    setSubStr('')
                                    onChangeSearchBar && onChangeSearchBar({ target: { value: '' } } as any)
                                }}
                            >
                                <Clear_Large />
                            </button>
                        )}
                    </div>
                    {/* list of all the options */}
                    <div className={selectListClasses.listContainer} ref={scrollContainerRef}>
                        {subStr.length === 0 &&
                            optionList.map((item: any) => {
                                return item.name && (
                                    <div className={selectListClasses.itemContainer} key={item.id}>
                                        <input
                                            className={selectListClasses.checkboxInput}
                                            type="checkbox"
                                            value={item.id}
                                            id={item.attribute_name}
                                            name={item.name}
                                            checked={selectedList.map(a => a.id).includes(item.id)}
                                            onChange={onChangeFilter} />
                                        <label
                                            className={selectListClasses.checkboxLabel}
                                        >
                                            {item.name}
                                        </label>
                                    </div>
                                )
                            })}
                        {subStr.length > 0 &&
                            optionList.map((item: any) => {
                                return item.name && item.name.toLowerCase().includes(subStr.toLowerCase()) && (
                                    <div className={selectListClasses.itemContainer} key={item.id}>
                                        <input
                                            className={selectListClasses.checkboxInput}
                                            type="checkbox"
                                            value={item.id}
                                            id={item.attribute_name}
                                            name={item.name}
                                            checked={selectedList.map(a => a.id).includes(item.id)}
                                            onChange={onChangeFilter} />
                                        <label
                                            className={selectListClasses.checkboxLabelHover}
                                        >
                                            {item.name}
                                        </label>
                                    </div>
                                )
                            })}
                    </div>
                    <label className={loadMore ? loading ? selectListClasses.loadingLabel : selectListClasses.loadMoreLabel : "hidden"} onClick={handleLoadMore}>{loading ? t("Loading") : t("Load More")}</label>
                </div>}

        </div>
    )
}

export default SelectList;